import { useEffect, useState } from "react";
import { usePaginatedQuery } from "convex/react";
import { api } from "@engineernow/convex-client";
import LoadMore from "../../components/Pagination/LoadMore";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ClipLoader } from "react-spinners";
import CustomDatePickerDropdown from "../../components/CustomDatePickerSelection";
import SideMenu from "../../components/SideMenu/SideMenu";
import { Container, ContentContainer, Loader } from "../Common.Styled";
import { Block, BlockContainer, BlockText, BlockTitle, PaymentChartContainer } from "./Payment.Styled";
import first from '../../assets/payments/1.svg';
import second from '../../assets/payments/2.svg';
import third from '../../assets/payments/3.svg';
import Chart from "../../components/Chart/Chart";
import Header from "../../components/Header/Header";
import Search from "../../components/Search/Search";
import { AccountItem, AccountsContainer, AccountsTitle, AccountTitle } from "../Accounts/Accounts.Styled";
import moment from "moment";
import { DataPoint, PaymentType } from "../types";
import { AddButton, ExcelIcon } from "../../components/Header/Header.Styled";
import { exportPayments, getPaymentsChart } from "../../services/payments";

function Payments() {

    type InfoType = {
        id: number,
        img: any,
        title: number,
        text: string,
        color: string
    }

    const [startDate, setStartDate] = useState<any>(null);
    const [endDate, setEndDate] = useState<any>(null);
    const [dateFilter, setDateFilter] = useState({
        start_date: undefined,
        end_date: undefined,
    });
    const [searcStr, setSearcStr] = useState<string>('');
    // Успешные платежи — подписка с курсором (по 10), поиск по email на сервере.
    const { results, status, loadMore } = usePaginatedQuery(
        api.admin.commerce.payments, searcStr ? { search: searcStr } : {}, { initialNumItems: 10 },
    );
    const payments: PaymentType[] | null = status === "LoadingFirstPage" ? null : results;
    const [chartData, setChartData] = useState<DataPoint[]>([]);

    const items = [{ id: 0, img: first, title: 0, text: 'Total number', color: '#FFA755' },
    { id: 1, img: second, title: 0, text: 'Stripe', color: '#68E366' },
    { id: 2, img: third, title: 0, text: 'Prodamus', color: '#812EC4' }];

    const [infoBlocks, setInfoBlocks] = useState<InfoType[]>(items);

    useEffect(() => {
        const now = new Date();
        setEndDate(now)
        const past = new Date();
        past.setDate(now.getDate() - 30);
        setStartDate(past);
    }, []);

    useEffect(() => {
        if (startDate && endDate) {
            getChart();
        }
    }, [startDate, endDate]);


    const createChartData = (data: PaymentType[]) => {
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        const formattedData: DataPoint[] = data.reduce((acc: DataPoint[], item: PaymentType) => {
            const date = new Date(item.date);
            const month = monthNames[date.getMonth()];

            let monthData = acc.find(d => d.name === month);
            if (!monthData) {
                monthData = { name: month };
                acc.push(monthData);
            }

            const providerKey = item.provider.charAt(0).toUpperCase() + item.provider.slice(1) as keyof DataPoint;
            if (providerKey === 'Stripe' || providerKey === 'Prodamus') {
                monthData[providerKey] = (monthData[providerKey] || 0) + parseFloat(String(item.amount));
            }

            return acc;
        }, []);

        formattedData.sort((a, b) => monthNames.indexOf(a.name) - monthNames.indexOf(b.name));

        setChartData(formattedData);
    };


    const handleExport = async () => {
        try {
            const requestBody = {
                startDate: moment(startDate).format('YYYY-MM-DD'),
                endDate: moment(endDate).format('YYYY-MM-DD'),
            };
    
            await exportPayments(requestBody);
        } catch (error) {
            console.error('Error exporting payments:', error);
            throw error;
        }
    };
    

    const getChart = async () => {
        try {
            const startDateFormatted = moment(startDate).format('YYYY-MM-DD');
            const endDateFormatted = moment(endDate).format('YYYY-MM-DD');

            const data = await getPaymentsChart(startDateFormatted, endDateFormatted);
                const updatedItems = infoBlocks.map(item => {
                    if (item.id === 0) {
                        item.title = data.prodamusPaymentsCount + data.stripePaymentsCount
                    }
                    else if (item.id === 1) {
                        item.title = data.stripePaymentsCount
                    }
                    else {
                        item.title = data.prodamusPaymentsCount
                    }
                    return item;
                }
                );
                setInfoBlocks(updatedItems);
                createChartData(data.payments)
        
        } catch (e) {
            console.log('get chart error', e);
        }
    }
    const onSearch = (text: string) => {
        setSearcStr(text);
    }
    return (
        <div style={{ display: 'flex' }}>
            <SideMenu />
            <ToastContainer />
            <Container >
                <ContentContainer>
                    <div className="d-flex align-items-center justify-content-end" style={{ marginRight: -15 }}>
                        <AddButton onClick={() => handleExport()} style={{ marginRight: 15 }}>
                            <ExcelIcon src={require('../../assets/excel.png')} />
                            Export to Excel
                        </AddButton>
                        <CustomDatePickerDropdown
                            startDate={startDate}
                            endDate={endDate}
                            setStartDate={setStartDate}
                            setEndDate={setEndDate}
                            dateFilter={dateFilter}
                            setDateFilter={setDateFilter}
                        />
                    </div>
                    <PaymentChartContainer>
                        <BlockContainer>
                            {infoBlocks && infoBlocks.map((item, index) => (
                                <Block style={{ background: item.color }}>
                                    <img src={item.img} alt="" />
                                    <div>
                                        <BlockTitle>
                                            {item.title}
                                        </BlockTitle>
                                        <BlockText>
                                            {item.text}
                                        </BlockText>
                                    </div>
                                </Block>
                            ))}
                        </BlockContainer>
                        <Chart data={chartData} />
                    </PaymentChartContainer>
                    <Header title={"Payments"}
                        buttonTitle={null}
                        text={null} />
                    <Search onClick={(text: string) => onSearch(text)} />
                    <AccountsContainer>
                        <AccountsTitle>
                            <AccountTitle>
                                Payment Provider
                            </AccountTitle>
                            <AccountTitle>
                                Email
                            </AccountTitle>
                            <AccountTitle>
                                Date of Purchase
                            </AccountTitle>
                            <AccountTitle >
                                Paid Amount
                            </AccountTitle>
                        </AccountsTitle>
                        {payments ? payments?.map((item: PaymentType, index: number) => {
                            return (
                                < AccountItem key={index} >
                                    <AccountTitle style={{ color: '#292D32' }}>
                                        {item.provider.charAt(0).toUpperCase() + item.provider.slice(1)}
                                    </AccountTitle>
                                    <AccountTitle style={{ color: '#292D32' }}>
                                        {item.email}
                                    </AccountTitle>
                                    <AccountTitle style={{ color: '#292D32' }}>
                                        {moment(item.date).format("DD MMM YYYY")}
                                    </AccountTitle>
                                    <AccountTitle style={{ color: '#292D32' }}>
                                        {`${item.amount} ${item.currency}`}
                                    </AccountTitle>
                                </AccountItem>
                            )
                        }) :
                            <Loader style={{ marginTop: '22vh' }}>
                                <ClipLoader
                                    color={'#3888FF'}
                                    size={70}
                                    data-testid="loader"
                                />
                            </Loader>}
                    </AccountsContainer>
                    <LoadMore status={status} loaded={results.length} label="payments" onLoadMore={() => loadMore(10)} />
                </ContentContainer>
            </Container>
        </div >

    )
}
export default Payments;